import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = import.meta.env.DEV
;(window as unknown as { Stimulus: Application }).Stimulus = application

// Auto-register every *_controller.ts in this directory as a Stimulus controller.
const modules = import.meta.glob<{ default: typeof import("@hotwired/stimulus").Controller }>(
  "./*_controller.ts",
  { eager: true },
)

for (const path in modules) {
  const name = path
    .replace(/^\.\//, "")
    .replace(/_controller\.ts$/, "")
    .replace(/_/g, "-")
  application.register(name, modules[path].default)
}

export { application }
